// WelcomeScreen.js - FINAL VERSION
import React, { useState } from 'react';
import '../components/VerificationComponents.css';

function WelcomeScreen() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const startVerification = async () => {
    setLoading(true);
    setError('');

    try {
      const token = localStorage.getItem('token');
      
      const response = await fetch('/api/kyc/create-verification-session', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          returnUrl: `${window.location.origin}/verification-complete`
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to create verification session');
      }

      const data = await response.json();

      // Redirect to Stripe Identity verification
      window.location.href = data.url;

    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', padding: '80px 20px' }}>
      <div className="welcome-card">
        {/* SIMPLE GREETING - NO NAME */}
        <h1>Welcome to Liber Astro</h1>
        <p className="subtitle">
          Your account has been successfully created. To gain access to the platform, we need to verify your identity using a standard US Government issued ID. This is to prevent fraud, and complies with US Know Your Customer (KYC) laws.
        </p>

        <div className="requirements" style={{ border: '1px solid #e5e7eb', borderRadius: '8px', padding: '20px', background: '#fff' }}>
          <h3>What you'll need:</h3>
          <ul>
            <li>A valid government-issued photo ID (driver's license or passport)</li>
            <li>Your phone or computer camera for a photo of yourself</li>
            <li>About 2-3 minutes</li>
          </ul>
        </div>

        {error && (
          <div style={{
            padding: '16px',
            background: '#fef2f2',
            border: '1px solid #fecaca',
            borderRadius: '8px',
            color: '#991b1b',
            fontSize: '14px',
            marginBottom: '24px',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        <div className="button-group">
          <button 
            className="btn-primary"
            onClick={startVerification}
            disabled={loading}
            style={{ opacity: loading ? 0.7 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
          >
            {loading ? 'Starting Verification...' : 'Verify My Identity Now'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default WelcomeScreen;
